// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__61cKj","card":"styles_card__PSnBZ","icon":"styles_icon__qUqt_","content":"styles_content__PNjND","img":"styles_img__pTLG4"};